"use client";

import { useEffect } from "react";

/**
 * Registers the PWA service worker (`/sw.js`) once, after first load.
 *
 * The SW powers Web Push (notification system Phase B). Registration is
 * deferred to the `load` event so it never competes with first paint.
 * Renders nothing.
 */
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;

    const register = () => {
      navigator.serviceWorker.register("/sw.js").catch((err) => {
        console.warn("[sw] registration failed:", err);
      });
    };

    if (document.readyState === "complete") {
      register();
    } else {
      window.addEventListener("load", register, { once: true });
      return () => window.removeEventListener("load", register);
    }
  }, []);

  return null;
}
